import Link from "next/link";
import { useRouter } from "next/router";
import clsx from "clsx";
import styles from "./index.module.scss";

export default function Menu({ isBaltex }) {
  const router = useRouter();

  let links = [
    ["Вопросы и ответы", "/faq"],
    ["Оплата", "/payment"],
    ["Доставка", "/delivery"],
    ["Возврат товара", "/refund"],
    ["Гарантия", "/warranty"],
    ["Сертификаты", "/certificates"],
  ];
  if (isBaltex) {
    links = [
      ["Для покупателей", "/info"],
      ["Вопросы и ответы", "/faq"],
      ["Гарантия", "/warranty"],
      ["Сертификаты", "/certificates"],
    ];
  }

  if (!isBaltex) {
    links.push(["Вакансии", "/job"]);
  }

  return (
    <nav className={clsx(isBaltex && styles.NavBaltex, styles.Nav)}>
      {links.map((link) => (
        <Link key={link[0]} href={link[1]}>
          <a className={router.pathname.includes(link[1]) && styles.Selected}>
            {link[0]}
          </a>
        </Link>
      ))}
    </nav>
  );
}
